import { useState, useEffect, useRef } from 'react';

// ── SVG icons for each nav tab ────────────────────────────────
const ICONS = {
  today: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
    </svg>
  ),
  pipeline: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
      <rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
    </svg>
  ),
  inprogress: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
    </svg>
  ),
  contacts: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
      <circle cx="9" cy="7" r="4"/>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    </svg>
  ),
  customers: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="12" y1="1" x2="12" y2="23"/>
      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
    </svg>
  ),
  analytics: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="20" x2="18" y2="10"/>
      <line x1="12" y1="20" x2="12" y2="4"/>
      <line x1="6" y1="20" x2="6" y2="14"/>
    </svg>
  ),
  outreach: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/>
      <polyline points="16 7 22 7 22 13"/>
    </svg>
  ),
  settings: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3"/>
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
    </svg>
  ),
  sync: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
      <polyline points="17 8 12 3 7 8"/>
      <line x1="12" y1="3" x2="12" y2="15"/>
    </svg>
  ),
};

const TABS = [
  { id: 'today',      label: 'Today',        dot: true  },
  { id: 'outreach',   label: 'Outreach',     dot: false },
  { id: 'inprogress', label: 'Trial Management', dot: true },
  { id: 'contacts',   label: 'Contacts'                 },
  { id: 'customers',  label: 'Customers'                },
  { id: 'analytics',  label: 'Analytics'                },
  { id: 'sync',       label: 'Sync BigDough'            },
];

const TAB_TITLES = {
  today:      'Today',
  inprogress: 'Trial Management',
  contacts:   'Contacts',
  customers:  'Customers',
  analytics:  'Analytics',
  sync:       'Sync BigDough',
};

// ── Helpers (unchanged logic) ─────────────────────────────────
function formatLastLoaded(date) {
  if (!date) return null;
  const now = Date.now();
  const diffMin = Math.round((now - date.getTime()) / 60000);
  if (diffMin < 1) return 'just now';
  if (diffMin < 60) return `${diffMin}m ago`;
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

function getInitials(name, email) {
  if (name) {
    const parts = name.trim().split(' ');
    return (parts[0][0] + (parts[1]?.[0] ?? '')).toUpperCase();
  }
  if (email) return email[0].toUpperCase();
  return '?';
}

export default function Layout({
  activeTab,
  topbarSuffix,
  onTabChange,
  onRefresh,
  lastLoaded,
  userEmail,
  userName,
  userAvatar,
  onSignOut,
  onSyncGmail,
  syncingGmail,
  syncGmailError,
  syncUsers = [],
  selectedSyncUsers = [],
  onSyncUsersChange,
  onSyncCalendar,
  syncingCalendar,
  syncCalendarError,
  onReconnectCalendar,
  onOpenSettings,
  isConnected,
  onConnect,
  children,
}) {
  const calendarNeedsReconnect = syncCalendarError && syncCalendarError.includes('reconnect');
  const lastLoadedStr = formatLastLoaded(lastLoaded);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [accountsOpen, setAccountsOpen] = useState(false);
  const accountsRef = useRef(null);
  const accountList = Array.from(new Set((syncUsers.length > 0 ? syncUsers : [userEmail]).filter(Boolean).map((u) => String(u).toLowerCase())));
  const selectedSet = new Set(selectedSyncUsers.map((u) => String(u).toLowerCase()));
  const selectedCount = accountList.filter((u) => selectedSet.has(u)).length;

  useEffect(() => {
    const onDocClick = (e) => {
      if (!accountsRef.current?.contains(e.target)) setAccountsOpen(false);
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, []);

  const toggleAccount = (email) => {
    const key = String(email).toLowerCase();
    const next = selectedSet.has(key)
      ? selectedSyncUsers.filter((u) => String(u).toLowerCase() !== key)
      : [...selectedSyncUsers, key];
    onSyncUsersChange?.(next.length > 0 ? next : [String(userEmail ?? '').toLowerCase()].filter(Boolean));
  };

  // Gmail chip state
  const gmailChipClass = syncingGmail ? 'sync-chip loading' : syncGmailError ? 'sync-chip error' : 'sync-chip';
  const gmailLabel = syncingGmail ? 'Gmail syncing…' : syncGmailError ? 'Gmail error' : 'Gmail';

  // Calendar chip state
  const calChipClass = syncingCalendar ? 'sync-chip loading' : syncCalendarError ? 'sync-chip error' : 'sync-chip';
  const calLabel = syncingCalendar ? 'Calendar syncing…' : calendarNeedsReconnect ? 'Reconnect Cal' : syncCalendarError ? 'Calendar error' : 'Calendar';

  return (
    <div className={`app${sidebarCollapsed ? ' collapsed' : ''}`}>

      {/* ── Sidebar ───────────────────────────────────── */}
      <aside className="sidebar">

        {/* Logo */}
        <div className="sidebar-logo">
          {/* Official Implied logomark + wordmark styling, matched to the
              lumosity_clients app sidebar (flat mark, charcoal wordmark). */}
          <div className="sidebar-logo-icon" style={{ background: 'transparent', width: 30, height: 30 }}>
            <img src="/implied-logomark.png" alt="" style={{ width: 30, height: 30, display: 'block' }} />
          </div>
          <div className="sidebar-logo-text">Implied <span>Sales</span></div>
          <button
            className="sidebar-collapse-btn"
            onClick={() => setSidebarCollapsed((v) => !v)}
            title={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
            aria-label={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="15 18 9 12 15 6"/>
            </svg>
          </button>
        </div>

        <div className="sidebar-section-label">Workspace</div>

        {/* Nav */}
        <nav>
          {TABS.map((tab) => (
            <button
              key={tab.id}
              className={`nav-item${activeTab === tab.id ? ' active' : ''}`}
              onClick={() => onTabChange(tab.id)}
              title={tab.label}
            >
              {ICONS[tab.id]}
              <span className="nav-item-label">{tab.label}</span>
              {tab.dot && <span className="nav-dot" />}
            </button>
          ))}
        </nav>

        <div className="nav-divider" />

        <nav>
          <button
            className="nav-item"
            onClick={onOpenSettings}
            title="Settings"
          >
            {ICONS.settings}
            <span className="nav-item-label">Settings</span>
          </button>
        </nav>

        {/* User */}
        <div className="sidebar-user">
          <div className="sidebar-avatar">
            {userAvatar
              ? <img src={userAvatar} alt="avatar" />
              : getInitials(userName, userEmail)
            }
          </div>
          <div className="sidebar-user-info">
            {userName && <div className="sidebar-user-name">{userName}</div>}
            <div className="sidebar-user-email">{userEmail ?? ''}</div>
            <button className="signout-btn" onClick={onSignOut}>Sign out</button>
          </div>
        </div>
      </aside>

      {/* ── Main ─────────────────────────────────────── */}
      <main className="main">

        {/* Topbar */}
        <header className="topbar">
          <div className="topbar-title">
            <div className="topbar-title-line" />
            <span>{TAB_TITLES[activeTab] ?? ''}</span>
            {topbarSuffix && <span className="topbar-title-suffix">{topbarSuffix}</span>}
          </div>

          <div className="topbar-actions">
            {/* Account selector */}
            <div style={{ position: 'relative' }} ref={accountsRef}>
              <button
                className="btn btn-ghost btn-sm"
                onClick={() => setAccountsOpen((v) => !v)}
                title="Choose which connected accounts to sync"
                aria-expanded={accountsOpen}
              >
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                  <circle cx="9" cy="7" r="4"/>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                </svg>
                {accountList.length} Account{accountList.length !== 1 ? 's' : ''}
              </button>
              {accountsOpen && (
                <div className="sync-picker__menu">
                  <div className="sync-picker__label">
                    Connected Accounts
                    <span className="sync-picker__count">{selectedCount} selected</span>
                  </div>
                  <div className="sync-picker__list">
                    {accountList.map((email) => (
                      <label key={email} className="sync-picker__item">
                        <input
                          type="checkbox"
                          checked={selectedSet.has(email)}
                          onChange={() => toggleAccount(email)}
                        />
                        <span>{email}</span>
                      </label>
                    ))}
                  </div>
                  {isConnected === false && (
                    <div className="sync-picker__connect">
                      <button className="btn btn--sm btn--primary" onClick={onConnect}>
                        Connect your Gmail &amp; Calendar
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Gmail sync chip */}
            <button
              className={gmailChipClass}
              onClick={onSyncGmail}
              disabled={syncingGmail}
              title={syncGmailError ?? (syncingGmail ? 'Syncing Gmail…' : 'Sync Gmail')}
              style={{ cursor: 'pointer', border: 'none' }}
            >
              <span className="sync-chip-dot" />
              {gmailLabel}
            </button>

            {/* Calendar sync chip */}
            <button
              className={calChipClass}
              onClick={calendarNeedsReconnect ? onReconnectCalendar : onSyncCalendar}
              disabled={syncingCalendar}
              title={
                calendarNeedsReconnect ? 'Click to reconnect and grant calendar access' :
                syncCalendarError ?? (syncingCalendar ? 'Syncing Calendar…' : 'Sync Calendar')
              }
              style={{ cursor: 'pointer', border: 'none' }}
            >
              <span className="sync-chip-dot" />
              {calLabel}
            </button>

            {/* Refresh */}
            <button className="btn btn-ghost btn-sm" onClick={onRefresh} title={lastLoadedStr ? `Last loaded ${lastLoadedStr}` : 'Refresh data'}>
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="1 4 1 10 7 10"/>
                <path d="M3.51 15a9 9 0 1 0 .49-3"/>
              </svg>
              Refresh{lastLoadedStr ? ` · ${lastLoadedStr}` : ''}
            </button>
          </div>
        </header>

        {/* Page content */}
        <div className="page-content">
          {children}
        </div>
      </main>
    </div>
  );
}
